import { render, staticRenderFns } from "./XingButton.vue?vue&type=template&id=bb4972b8&scoped=true&"
import script from "./XingButton.vue?vue&type=script&lang=js&"
export * from "./XingButton.vue?vue&type=script&lang=js&"
import style0 from "./XingButton.vue?vue&type=style&index=0&id=bb4972b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4972b8",
  null
  
)

export default component.exports